import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { DropdownSelect } from "@vds/selects";
import { Button, TextLink } from "@vds/buttons";
import styled from "styled-components";
import { Line } from "@vds/lines";
import { Col, Grid, Row } from "@vds/grids";
import { Icon } from "@vds/icons";
import {
    Accordion,
    AccordionDetail,
    AccordionHeader,
    AccordionItem,
    AccordionTitle,
} from "@vds/accordions";
import {
    ListGroup,
    ListGroupItem,
    ListGroupItemTitle,
} from "@vds/lists";
import { Body, Title } from "@vds/typography";
import { TextArea } from "@vds/inputs";
import {DatePicker} from "@vds/date-pickers";
import { MarginSpacerM, MarginSpacerS, MarginSpacerXL , MarginSpacer2XL} from "common/components/styleTag.js";
import { RadioButtonGroup } from "@vds/radio-buttons";
import { getStoreAppointmentDetails, setSelectedAppointmentDetails, setStoreQueryParams } from "pages/Mobility/ducks/MobilitySlice";
import ErrorBoundary from "common/components/ErrorBoundary/ErrorBoundary";
import StoreAddress from "../StoreAddress/StoreAddress";
import { useMediaQuery } from "react-responsive";

const Container = styled.div`
margin: 0.5rem 0 5rem 0;
  > div [class*="row-padding"] {
    padding-left : 25px;
    padding-right : 20px; 
    >div[class*="header-width"]{
        width: 90%
    }
  }
  >div >div div [class*="juIDGL"]{
    flex-direction : row;
    column-gap : 20px;
  }
  .time-dropdownSelect div[class*='SelectContainer-']{
    min-width: 175px;
  }
  .time-dropdownSelect div[class*='SelectContainer-'] select{
    min-width: 191px;
  }
  .time-dropdownSelect div[class*='SelectContainer-'] span{
   right: 6px;
  }
 
 
  @media only screen and (max-width: 767px) {
    margin: 1rem
  }
`;
const HeaderButton = styled.div`
>div div >button{
    padding-top: 10px;
    padding-bottom:10px;
    >span {
        top: 12px;
        }
    }
}
// >div [class*="biPaJB"]:{
//     background-color : #000;
// }

`
const ContactWrapper = styled.div`
display:flex;
align-items:center;
justify-content: flex-end;
}
`;
const AccordionDetailList = styled.div`
border: #e8e9e9 solid 1px;
>div >div >div[class*="juLbtG"]{
    padding-top: 0.7rem;
    padding-bottom: 0.7rem;
    border-bottom: #e8e9e9 solid 1px;
}
>div >div >div >div[class*="bNvcNW"]{
    padding: 0 10px;
    >span > p >p {
    color : grey;
    font-weight: bold;
    font-weight: medium;
    &:hover {
        color : black;
       }
       >a{
        text-decoration: none;
       color: inherit;
    }}
  }
`
const CustomRadioButtonGroup = styled(RadioButtonGroup)`
display: flex!important;
flex-direction : row;
column-gap : 30px;
>div >label {
    font-size: small;
    >div >span[class*="cLgMcI"]{
        font-weight: normal;
    }
}
>div[class*="ComponentWrapper-VDS__sc-bccgul-0"] {
    margin-top : 0;
}
`;

const CustomLine = styled(Line)`
height: 0.25rem;
background-color:#000;
`
export const StoreButtonWrapper = styled.div`
    margin: 1.5rem 0;
    padding-top:${({isMobile})=>(isMobile ? "0px" : "155px")};
    >button{
        padding : 0 20px;
    }
`

export const CustomTextLink = styled(TextLink)`
    border-bottom: none;
    &:hover{
        border-bottom: none;
        color: #000000;
    }
    `
const StoreAppointment = (props, ref) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pageData = useSelector((state) => state.MobilityPage);
    const [appointmentType, setAppointmentType] = useState('In-Store');
    const { t, i18n } = useTranslation(["app"]);
    const [customerOptions, setCustomerOptions] = useState(
        t("app.common.appointmentOptions", { ns: "app", returnObjects: true }) ?? []
    )
    const [purposeOfVisit, setPurposeOfVisit] = useState('');
    const [isShowOption, setIsShowOption] = useState(false)
    const [appointmentDate, setAppointmentDate] = useState("");
    const [dayOpen, setDayOpen] = useState("");
    const [dayClose, setDayClose] = useState("");
    // const [openTimeOfStore, setOpenTimeOfStore] = useState("");
    const [storeOpenTime, setStoreOpenTime] = useState("");
    const [storeCloseTime, setStoreCloseTime] = useState("");
    // const [closeTimeOfStore, setCloseTimeOfStore] = useState("");
    const [timeOfOpening, setTimeOfOpening] = useState("");
    const [timeOfClosing, setTimeOfClosing] = useState("");
    const [minOfOpening, setMinOfOpening] = useState("");
    const [minOfClosing, setMinOfClosing] = useState("");
    const [morningList, setMorningList] = useState([]);
    const [afternoonList, setAfternoonList] = useState([]);
    const [eveningList, setEveningList] = useState([]);
    const [activeDatesDays, setActiveDatesDays] = useState([]);
    const [requestedTimeSlot, setRequestedTimeSlot] = useState('');
    const [requestedTime, setRequestedTime] = useState('');
    const [additionalComments, setAdditionalComments] = useState('');
    const [allSlotClosed, setAllSlotClosed] = useState(false);
    const { storeAppointmentInfo, selectedAppointmentDetails } = pageData
    let calendarInput = ""
    let pathUrl = window?.location?.search?.split("&")
    let storeIdUrl = pathUrl[0]?.split("=")
    let storeId = storeIdUrl && storeIdUrl[1]
    let channelUrl = pathUrl[1]?.split("=")
    let channel = channelUrl && channelUrl[1]
    const calendarRef = useRef(null);
    const isMobile = useMediaQuery({
        query: "(max-width: 545px)",
      });
    useEffect(() => {
        let storeObj = {
            storeId: storeId,
            channel: channel
        }
        dispatch(getStoreAppointmentDetails(storeObj))
        dispatch(setStoreQueryParams(storeObj))
    }, [storeId])

    const  handleAddtionalComments = (e) => {
        let val = e.target.value
        if(val.length <= 200){
            setAdditionalComments(val)
        }
    }

    useEffect(() => {
        if(Object.keys(storeAppointmentInfo).length>0 && appointmentDate){
            setTimeout(() => {
        setSlotData()
            }, 3000)
        }
    }, [storeAppointmentInfo, appointmentDate])

    useEffect(() => {
        getActiveDates()
    }, [])

    useEffect(() => {
        if(activeDatesDays.length >0){
        setTimeout(() => {
            setSlotData()
                }, 3000)
            }
    }, [activeDatesDays])

    const splitOpenHours = (timeOfOpening, timeOfClosing, minOfOpening, minOfClosing) => {

        // to handle condition of showing slots 1 hr prior to closing time only
        if (!minOfOpening?.includes('00')) {
            timeOfOpening = timeOfOpening + 1;
        }
       let upDatedTimeOfClosing = timeOfClosing - 1;
        let morningSlots = [];
        let afternoonSlots = [];
        let eveningSlot = [];
        if (timeOfOpening < 12) {
            for (let i = timeOfOpening; i < 12; i++) {
                morningSlots.push(i);
            }
        }

        if (timeOfOpening <= 12 && upDatedTimeOfClosing > 2) {
            for (let i = 12; i < 14; i++) {
                if (i === 12)
                    afternoonSlots.push(i);
                else
                    afternoonSlots.push(i - 12);
            }
        }

        if (timeOfOpening <= 12 && upDatedTimeOfClosing == 1) {
            for (let i = 12; i < 13; i++) {
                if (i === 12)
                    afternoonSlots.push(i);
                else
                    afternoonSlots.push(i - 12);
            }
        }

        if (upDatedTimeOfClosing > 2) {
            for (let i = 2; i < 4; i++) {
                eveningSlot.push(i);
            }
        }

        return {
            morningSlots,
            afternoonSlots,
            eveningSlot,
        }

    }

    const handleRequestedTime = (value, key) => {
       if(value?.trim() === "Morning" || value?.trim() ==="Afternoon" ||value?.trim() ==="Evening"){
        setRequestedTime("")
        setRequestedTimeSlot(key)
       }else{
        setRequestedTime(value)
        setRequestedTimeSlot(key)
       }
    }

    const setSlotData = () => {
        let updatedselectedDate = appointmentDate == "" ? new Date(activeDatesDays[0]) : new Date(appointmentDate)
         findDayOpenAndClose(updatedselectedDate?.getDay());
         if(appointmentDate===""){
            setAppointmentDate(new Date(activeDatesDays[0]))
         }
    }

    useEffect(() => {
        let timings =storeAppointmentInfo && storeAppointmentInfo?.storeDetail && storeAppointmentInfo?.storeDetail?.timings ||[] 
        let  openTimeOfStore = timings[`${dayOpen}`]
        let  closeTimeOfStore = timings[`${dayClose}`]
        setStoreOpenTime(timings[`${dayOpen}`]);
        setStoreCloseTime(timings[`${dayClose}`]);
        if (openTimeOfStore !== 'Closed') {
            let timeOfOpening = Number(openTimeOfStore?.split(':')[0]);
            let timeOfClosing = Number(closeTimeOfStore?.split(':')[0]);
            let minOfOpening = openTimeOfStore?.split(':')[1];
            let minOfClosing = closeTimeOfStore?.split(':')[1];
            if (timeOfOpening < 9) {
                setTimeOfOpening(9)
            }

            if (timeOfClosing > 5) {
                setTimeOfClosing(5);
            }
            const slottedtime = splitOpenHours(timeOfOpening, timeOfClosing, minOfOpening, minOfOpening);
            let morningSlotsList = [];
            let afternoonSlotsList = [];
            let eveningSlotsList = [];
            if (slottedtime?.morningSlots?.length > 0) {
                slottedtime?.morningSlots?.forEach(e => {
                    const f = Number(e);
                    if ((f + 1) % 13 !== 12) {
                        morningSlotsList?.push({
                            OptionListValue: e + ':00AM - ' + (f + 1) % 13 + ':00AM'
                        });
                    } else {
                        morningSlotsList?.push({
                            OptionListValue: e + ':00AM - ' + (f + 1) % 13 + ':00PM'
                        });
                    }

                });
            } else {
                morningSlotsList = [];
            }
            if (slottedtime?.afternoonSlots?.length > 0) {
                slottedtime.afternoonSlots.forEach(e => {
                    const f = Number(e);
                    afternoonSlotsList.push({
                        OptionListValue: e + ':00PM - ' + (f + 1) % 12 + ':00PM'
                    });
                });
            } else {
                afternoonSlotsList = []
            }
            if (slottedtime?.eveningSlot?.length > 0) {
                slottedtime.eveningSlot.forEach(e => {
                    const f = Number(e);
                    eveningSlotsList.push({
                        OptionListValue: e + ':00PM - ' + (f + 1) % 12 + ':00PM'
                    });
                });
            } else {
                eveningSlotsList = []
            }
            setAllSlotClosed(false);
            setMorningList(morningSlotsList)
            setAfternoonList(afternoonSlotsList)
            setEveningList(eveningSlotsList)
        } else {
            setMorningList([])
            setAfternoonList([])
            setEveningList([])
            setAllSlotClosed(true);
        }
    }, [dayOpen, dayClose, appointmentDate])

    const getActiveDates = () =>{
        const activeDays = [];
        const curr = new Date(); 
        const first = curr.getDate() + 2;
        let appointmentDayLimit= storeAppointmentInfo?.storeDetail?.appointmentDayLimit ?storeAppointmentInfo?.storeDetail?.appointmentDayLimit : 14;
        for (let i = first; i < first + appointmentDayLimit; i++) {
          let day = new Date(curr.setDate(i)).toISOString();
          activeDays.push(day);
        }
        setActiveDatesDays(activeDays)
      }


    useEffect(() => {
        if (selectedAppointmentDetails?.appointmentType) {
            const {
                appointmentType,
                purposeOfVisit,
                appointmentDate,
                requestedTime,
                requestedTimeSlot,
                additionalComments
            } = selectedAppointmentDetails
            setAppointmentType(appointmentType)
            setPurposeOfVisit(purposeOfVisit)
            setAppointmentDate(appointmentDate)
            setRequestedTime(requestedTime)
            setRequestedTimeSlot(requestedTimeSlot)
            setAdditionalComments(additionalComments)
        }
    }, [selectedAppointmentDetails])

    const findDayOpenAndClose = (day) => {
        let updatedDay = (day >=6 ||  day == 0) ? 1 : day
        switch (updatedDay) {
            case 1: {
                setDayOpen('monOpen');
                setDayClose('monClose');
                break;
            }
            case 2: {
                setDayOpen('tueOpen');
                setDayClose('tueClose');
                break;
            }
            case 3: {
                setDayOpen('wedOpen');
                setDayClose('wedClose');
                break;
            }
            case 4: {
                setDayOpen('thuOpen');
                setDayClose('thuClose');
                break;
            }
            case 5: {
                setDayOpen('friOpen');
                setDayClose('friClose');
                break;
            }
            // case 6: {
            //     setDayOpen('satOpen');
            //     setDayClose('satClose');
            //     break;
            // }
            // case 7: {
            //     setDayOpen('sunOpen');
            //     setDayClose('sunClose');
            //     break;
            // }
        }
    };

    const onSelectDate = (date) => {
        setAppointmentDate(date)
    };

    const onClickContinue = () => {
        let appoinmentDetails = {
            appointmentType,
            purposeOfVisit,
            appointmentDate,
            requestedTime,
            requestedTimeSlot,
            additionalComments
        }
        dispatch(setSelectedAppointmentDetails(appoinmentDetails))
        navigate(`/shop/store-appointment/customer-details`)
    };

    const handlePhoneFormat = (phone) => {
        phone = phone?.replace(/(\d{3})(\d{3})(\d{4})/gi, '$1.$2.$3');
        return phone;
    }
    return (
        <ErrorBoundary>
            <Container>
                <Grid
                    colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
                    colGutter={false}
                >
                    <Row >
                        <Col className="row-padding" colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}>
                            <Row className="header-width">
                                <Title bold size='XLarge'>
                                    {t("app.common.storeAppointment.heading", { ns: "app" })}
                                </Title>
                            </Row>
                            <MarginSpacerM />
                            <Row className="header-width">
                                <Body bold size="large" >
                                    {t("app.common.storeAppointment.title", { ns: "app" })}
                                </Body>
                            </Row>
                            <MarginSpacerM />
                            <Row className="header-width">
                                <Body size="small" >
                                    {t("app.common.storeAppointment.subtitle", { ns: "app" })}
                                </Body>
                            </Row>
                            <MarginSpacerXL />
                        </Col>
                        {/* <Col colSizes={{ mobile: 0, tablet: 1, desktop: 1 }}>
                        </Col> */}
                        <Col className="row-padding" colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}>
                            <Row>
                            <MarginSpacer2XL />
                            </Row>
                            <MarginSpacerS />
                            {storeAppointmentInfo?.storeDetail &&
                                <ContactWrapper>
                                    <Icon
                                        name="phone"
                                        color="#000000"
                                        size="medium"
                                    />
                                    {isMobile ?
                                        <Body size="medium" >
                                            <CustomTextLink
                                                type="inline"
                                                href={`tel:${storeAppointmentInfo?.storeDetail?.corporateStore ?
                                                    t("app.common.storeAppointment.TollFreeNumber", { ns: "app" }) :
                                                    handlePhoneFormat(storeAppointmentInfo?.storeDetail?.phoneNumber)}`}
                                            >
                                                {storeAppointmentInfo?.storeDetail?.corporateStore ?
                                                    t("app.common.storeAppointment.TollFreeNumber", { ns: "app" }) : handlePhoneFormat(storeAppointmentInfo?.storeDetail?.phoneNumber)}
                                            </CustomTextLink>

                                        </Body> :
                                        <Body size="medium" >
                                            {storeAppointmentInfo?.storeDetail?.corporateStore ?
                                                t("app.common.storeAppointment.TollFreeNumber", { ns: "app" }) : handlePhoneFormat(storeAppointmentInfo?.storeDetail?.phoneNumber)}
                                        </Body>
                                    }
                                </ContactWrapper>
                                }
                                <MarginSpacerS />
                            <Row>
                            <StoreAddress
                                storeAppointmentInfo={storeAppointmentInfo}
                            />
                            </Row>
                            <MarginSpacerXL />
                        </Col>
                    </Row>
                    <Row>
                        <Col  colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}>
                            <Grid>
                                <Row>
                                    <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                                        <Title bold size='small'>
                                            {t("app.common.storeAppointment.options.appointmentType", { ns: "app" })}
                                        </Title>
                                        <MarginSpacerS />
                                        <CustomLine type="heavy" />
                                        <MarginSpacerS />
                                        <CustomRadioButtonGroup
                                            onChange={(e) => setAppointmentType(e.target.value)}
                                            defaultValue={selectedAppointmentDetails?.appointmentType ? selectedAppointmentDetails?.appointmentType : appointmentType}
                                            error={false}
                                            data={[
                                                {
                                                    name: "group",
                                                    label: "In-Store",
                                                    value: "instore",
                                                    ariaLabel: "radio one",
                                                    disabled: false,
                                                },
                                                {
                                                    name: "group",
                                                    label: "Virtual",
                                                    value: "Virtual",
                                                    ariaLabel: "radio two",
                                                    disabled: false,
                                                },
                                            ]}
                                        />
                                         <MarginSpacer2XL />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                                        <Title bold size='small'>
                                            {t("app.common.storeAppointment.options.helpWith", { ns: "app" })}
                                        </Title>
                                        <CustomLine type="heavy" />
                                        <Accordion
                                            type="multi">
                                                <HeaderButton>
                                            <AccordionItem opened={isShowOption}>
                                                <AccordionHeader
                                                     className='header-button' onClick={() => {
                                                    setIsShowOption(!isShowOption);
                                                }}

                                                    triggerType="icon">
                                                <AccordionTitle>{purposeOfVisit?.item ? purposeOfVisit?.item : " Select One"}</AccordionTitle>
                                                </AccordionHeader>
                                                <AccordionDetail>
                                                    <AccordionDetailList>
                                                        <ListGroup
                                                            topLine={true}
                                                            bottomLine={true}
                                                            leftLine={true}
                                                            rightLine={true}
                                                            surface="light"
                                                            viewport="mobile"
                                                        >
                                                            {customerOptions?.map(obj => {
                                                                return (
                                                                    <ListGroupItem actionElement="false"
                                                                        onClick={() => {
                                                                            setPurposeOfVisit(obj)
                                                                            setIsShowOption(!isShowOption)
                                                                        }}
                                                                    >
                                                                        <ListGroupItemTitle bold={false}   >
                                                                            {obj?.type ? <Body bold type="large">
                                                                                <a href={`${obj?.defaultLink}`}>
                                                                                    {obj?.item}
                                                                                </a>
                                                                            </Body> :
                                                                                <Body bold type="large"> {obj?.item}</Body>
                                                                            }
                                                                        </ListGroupItemTitle>
                                                                    </ListGroupItem >
                                                                )
                                                            })}
                                                        </ListGroup>
                                                    </AccordionDetailList>
                                                </AccordionDetail>
                                            </AccordionItem>
                                            </HeaderButton>
                                        </Accordion>
                                        <MarginSpacer2XL />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                                        <Title bold size='small'>
                                            {t("app.common.storeAppointment.options.dayTime", { ns: "app" })}
                                        </Title>
                                        <MarginSpacerS />
                                        <CustomLine className="divider" />
                                        <MarginSpacerS />
                                        <DatePicker
                                            dateFormat="MM/DD/YYYY"
                                            alwaysOpen={false}
                                            readOnly={false}
                                            disabled={purposeOfVisit?.item ? false : true}
                                            surface="light"
                                            onChange={(e) => onSelectDate(e)}
                                            selectedDate={appointmentDate ==="" ? new Date(activeDatesDays[0]) : new Date(appointmentDate)}
                                            activeDates={activeDatesDays}
                                            minDate={new Date()}
                                            label="Date"
                                            helperText=""
                                            helperTextPlacement="bottom"
                                        />
                                        <MarginSpacerM />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col colSizes={{ mobile: 4, tablet: 4, desktop: 4 }}>
                                        <Body bold  size="medium" >
                                      {(storeOpenTime && storeOpenTime) ? <option disabled={purposeOfVisit?.item ? false : true}> Store Availability:  {!allSlotClosed ?
                                                 `${storeOpenTime} to ${storeCloseTime}` :
                                                "Store Closed"}
                                                </option> : ""}
                                        </Body>
                                        <MarginSpacerM />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col colSizes={{ mobile: 4, tablet: 4, desktop: 4 }}>
                                        <DropdownSelect
                                            error={false}
                                            disabled={purposeOfVisit?.item ? false : true}
                                            className="time-dropdownSelect"
                                            readOnly={false}
                                            inlineLabel={true}
                                            value={requestedTime}
                                            helperTextPlacement="bottom"
                                            onChange={(e) => handleRequestedTime(e.target.value, "Morning")}
                                        >
                                            <option>
                                            &nbsp;&nbsp;&nbsp;Morning
                                            </option>
                                            {morningList?.map(slot => {
                                                return (
                                                    <option value={slot.OptionListValue}>
                                                        &nbsp;&nbsp;{slot?.OptionListValue}
                                                    </option>
                                                )
                                            })}
                                        </DropdownSelect>
                                    </Col>
                                    <Col colSizes={{ mobile: 4, tablet: 4, desktop: 4 }}>
                                        <DropdownSelect
                                            error={false}
                                            disabled={purposeOfVisit?.item ? false : true}
                                            className="time-dropdownSelect"
                                            readOnly={false}
                                            inlineLabel={false}
                                            value={requestedTime}
                                            helperTextPlacement="bottom"
                                            onChange={(e) => handleRequestedTime(e.target.value, "Afternoon")}
                                        >
                                            <option>
                                                Afternoon
                                            </option>
                                            {afternoonList?.map(slot => {
                                                return (
                                                    <option value={slot.OptionListValue}>
                                                        {slot?.OptionListValue}
                                                    </option>
                                                )
                                            })}
                                        </DropdownSelect>
                                    </Col>
                                    <Col colSizes={{ mobile: 4, tablet: 4, desktop: 4 }}>
                                        <DropdownSelect
                                            error={false}
                                            disabled={purposeOfVisit?.item ? false : true}
                                            className="time-dropdownSelect"
                                            readOnly={false}
                                            inlineLabel={false}
                                            value={requestedTime}
                                            helperTextPlacement="bottom"
                                            onChange={(e) => handleRequestedTime(e.target.value, "Evening")}
                                        >
                                            <option>
                                                Evening
                                            </option>
                                            {eveningList?.map(slot => {
                                                return (
                                                    <option value={slot.OptionListValue}>
                                                        {slot?.OptionListValue}
                                                    </option>
                                                )
                                            })}
                                        </DropdownSelect>
                                    </Col>
                                </Row>
                            </Grid>
                        </Col>
                        {/* <Col colSizes={{ mobile: 0, tablet: 1, desktop: 1 }}></Col> */}
                        <Col className="row-padding" colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}>
                        {isMobile ? <MarginSpacer2XL /> :<></>}
                            <Row>
                                <Title bold size='small'>
                                    {t("app.common.storeAppointment.options.additionalComments", { ns: "app" })}
                                </Title>
                                <MarginSpacerS />
                                <CustomLine className="divider" />
                                <MarginSpacerS />
                                <TextArea
                                    // label="Feedback"
                                    surface="light"
                                    readOnly={false}
                                    required={false}
                                    disabled={false}
                                    error={additionalComments?.length>200 ? true : false}
                                    value={additionalComments}
                                    helperText={t("app.common.storeAppointment.helperText", { ns: "app" })}
                                    // helperTextPlacement="bottom"
                                    onChange={(e) => handleAddtionalComments(e)}
                                    maxLength={200}
                                     />
                                     <MarginSpacer2XL />
                            </Row>
                            <Row>
                                <Col>
                                <MarginSpacer2XL />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                <MarginSpacer2XL />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                <MarginSpacer2XL />
                                {(
                                    <div className="disclaimer-action">
                                        <StoreButtonWrapper>
                                            <Button
                                                name="lq-widget-continuebutton"
                                                id="lq-widget-continuebutton"
                                                disabled={!(purposeOfVisit !== "" && appointmentDate !== "" && requestedTime !== "")}
                                                onClick={() => {
                                                    onClickContinue();
                                                }}
                                                data-analyticstrack="Continue:Company Information"
                                            >
                                                {t("app.common.page-stepper.continue-btn", { ns: "app" })}
                                            </Button>
                                        </StoreButtonWrapper>
                                    </div>
                                )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Grid>
            </Container>
        </ErrorBoundary>
    );
};
export default StoreAppointment;